export function summarizeCetele(detail, filter = 'all') {
  const students = detail?.students || [];
  const controls = [...(detail?.controls || [])].sort((a, b) => a.position - b.position);
  const byKey = new Map((detail?.results || []).map(r =>
    [String(r.student_id) + ':' + String(r.control_id), r.status]));
  const latest = student => {
    for (let i = controls.length - 1; i >= 0; i -= 1) {
      const status = byKey.get(String(student.id) + ':' + String(controls[i].id));
      if (status) return status;
    }
    return null;
  };
  const visible = students.filter(s => filter === 'all' ||
    (filter === 'none' ? latest(s) === null : latest(s) === filter));
  const counts = { pass: 0, retry: 0 };
  for (const student of visible) for (const control of controls) {
    const status = byKey.get(String(student.id) + ':' + String(control.id));
    if (status === 'pass' || status === 'retry') counts[status]++;
  }
  return { visible, latest, byKey, counts, total: counts.pass + counts.retry };
}
